'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Img_Img = require('../Img/Img.cjs.js');
const components_display_SkeletonLoader_SkeletonBlock_SkeletonBlock = require('../SkeletonLoader/SkeletonBlock/SkeletonBlock.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const placeholder = "_placeholder_k4asm_1";
const styles = {
	placeholder: placeholder
};

const ImgSkeletonLoader = (props) => {
  const [ratioWidth, ratioHeight] = (props.aspectRatio || "").split(":").map((part) => {
    return part && parseFloat(part);
  });
  const aspectRatio = ratioWidth && ratioHeight ? ratioWidth / ratioHeight : void 0;
  return React__default.default.createElement(components_display_SkeletonLoader_SkeletonBlock_SkeletonBlock.SkeletonBlock, { aspectRatio, height: props.height, width: props.width === null ? void 0 : props.width });
};
const LoadableImg = (props) => {
  const [loaded, setLoaded] = React.useState(false);
  const onLoad = (event) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(event);
    }
    setLoaded(true);
  };
  return React__default.default.createElement(
    "div",
    { "data-zds": true },
    React__default.default.createElement(
      "div",
      { className: loaded ? void 0 : styles.placeholder, "data-zds": true },
      React__default.default.createElement(components_display_Img_Img.Img, Object.assign({}, props, { onLoad }))
    ),
    !loaded && React__default.default.createElement(ImgSkeletonLoader, Object.assign({}, props))
  );
};

exports.LoadableImg = LoadableImg;
//# sourceMappingURL=LoadableImg.cjs.js.map
